let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Rw6X")).then(() => parcelRequire('k46Qr'));